var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFundamental(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#ffffff",
    stroke: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#ffffff;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}")), /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 49",
    id: "Layer_49"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 24,
    width: 24,
    x: 20,
    y: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 12.78,
    width: 12.78,
    x: 25.61,
    y: 50.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 12.78,
    width: 12.78,
    x: 1.08,
    y: 50.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 12.78,
    width: 12.78,
    x: 50.13,
    y: 50.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 32,
    x2: 32,
    y1: 25.33,
    y2: 50.23
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "56.52 50.23 56.52 33.83 7.48 33.83 7.48 50.23"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFundamental);
export default __webpack_public_path__ + "static/media/fundamental.0457508e597c7e32ffc4a4f66b939eb0.svg";
export { ForwardRef as ReactComponent };